import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { stateSelectors } from "@client/selectors";
import { type AppState } from "@client/types";
import { localStateSelector } from "../selectors";
import Component, { type BlogDetailPostProps } from "./component";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): BlogDetailPostProps => {
    const localState = localStateSelector(state, props);

    return {
      ...getEntityRef(props),
      labels: state.labels,
      portalId: state.portal.id,
      pageId: state.page.variantId,
      styleSheet: stateSelectors.styleSheetDataSelector(state),
      content: localState.content!
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
